import { render, staticRenderFns } from "./GenericMovieListCard.vue?vue&type=template&id=fa4def6e&scoped=true"
import script from "./GenericMovieListCard.vue?vue&type=script&lang=js"
export * from "./GenericMovieListCard.vue?vue&type=script&lang=js"
import style0 from "./GenericMovieListCard.vue?vue&type=style&index=0&id=fa4def6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa4def6e",
  null
  
)

export default component.exports